module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ShareButton"
  }, [_c('button-component', {
    staticClass: "ShareButton-button",
    attrs: {
      "label": _vm.label,
      "icon": "share"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openModal.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ShareButton-content"
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e931e82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareButton.vue
// module id = 752
// module chunks = 1474